import { createStyles, Theme, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        list: {
            marginTop: theme.spacing(),
        },
    })
);
